/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.23",
    versionName: "0.2.0-nightly.2026.2.23",
    versionChannel: "nightly",
    buildDate: "2026-02-23T00:11:32.338Z",
    commitHash: "88c2200decf6a55793f64388f8c5d9ca7e373289",
};
